var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Warning-Octagon--Streamline-Core",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Warning Octagon Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "warning-octagon--frame-alert-warning-octagon-exclamation-caution"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fill: "#ff4869",
    fillRule: "evenodd",
    d: "M3.85355 0.43934C4.13486 0.158035 4.51639 0 4.91421 0h4.17158c0.39782 0 0.77935 0.158035 1.06061 0.43934l3.4143 3.41421c0.2813 0.28131 0.4393 0.66284 0.4393 1.06066v4.17158c0 0.39782 -0.158 0.77935 -0.4393 1.06061l-3.4143 3.4143C9.86514 13.842 9.48361 14 9.08579 14H4.91421c-0.39782 0 -0.77935 -0.158 -1.06066 -0.4393L0.43934 10.1464C0.158035 9.86514 0 9.48361 0 9.08579V4.91421c0 -0.39782 0.158035 -0.77935 0.43934 -1.06066L3.85355 0.43934ZM7 3.125c0.41421 0 0.75 0.33579 0.75 0.75v3.25c0 0.41421 -0.33579 0.75 -0.75 0.75s-0.75 -0.33579 -0.75 -0.75v-3.25c0 -0.41421 0.33579 -0.75 0.75 -0.75Zm1 6.75c0 0.5523 -0.44772 1 -1 1s-1 -0.4477 -1 -1c0 -0.55228 0.44772 -1 1 -1s1 0.44772 1 1Z",
    clipRule: "evenodd",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIconRed);
export default __webpack_public_path__ + "static/media/warning-icon-red.2391d903b35ca27f4ede492a7c5dd915.svg";
export { ForwardRef as ReactComponent };